const maskValue = (value) => {
    // Replace everything but the last 4 characters with asterisks.
    if (typeof value === 'string' && value.length > 4) {
        return value.slice(0, -4).replace(/./g, '*') + value.slice(-4);
    }

    return value;
};

const sanitizeLoggedObject = (object) => {
    const maskedKeys = ['apiKey', 'Authorization'];

    if (Array.isArray(object)) {
        return object.map(sanitizeLoggedObject);
    }

    if (object !== null && typeof object === 'object') {
        return Object.fromEntries(
            Object.entries(object).map(([key, value]) => [
                key,
                maskedKeys.includes(key)
                    ? maskValue(value)
                    : sanitizeLoggedObject(value),
            ])
        );
    }

    return object;
};

module.exports = {
    maskValue,
    sanitizeLoggedObject,
};
